export interface INote {
    id?: string;
    text?: string;
    noteText?: string;
    createdBy?: string;
    createdOn?: string;
    noteSource?: string;
    icon?: string;
    iconBgColor?: string;
}

export class Note implements INote {
    id?: string;
    text?: string;
    noteText?: string;
    createdBy?: string;
    createdOn?: string;
    noteSource?: string;
    icon?: string;
    iconBgColor?: string;

    constructor(input: Partial<INote>) {
        Object.assign(this, input);
    }
}

export interface IMemberNote extends INote {
    memberId: string;
    caseId?: number;
}

export class MemberNote extends Note implements IMemberNote {
    id?: string;
    memberId: string;
    caseId: number;
    noteText?: string;
    text?: string;
    createdBy?: string;
    createdOn?: string;
    noteSource?: string;
    icon?: string;
    iconBgColor?: string;
    createdByObjectId?: string;

    constructor(input: any);
    constructor(id: number, memberId: string, caseId: string, noteText: string, createdBy: string, createdOn?: string, noteSource?: string, icon?: string, iconBgColor?: string);
    constructor(idOrObject: any, memberId?: string, caseId?: string, noteText?: string, createdBy?: string, createdOn?: string, noteSource?: string, icon?: string, iconBgColor?: string) {
        super(null);
        const pivot = idOrObject || noteText;
        if (typeof pivot === 'number' || typeof pivot === 'string') {
            this.id = idOrObject as string;
            this.memberId = memberId;
            this.noteText = noteText;
            this.createdBy = createdBy;
            this.createdOn = createdOn;
            this.noteSource = noteSource;
            this.icon = icon;
            this.iconBgColor = iconBgColor;
        } else {
            const internal = (idOrObject || {}) as MemberNote;
            this.id = internal.id;
            this.memberId = internal.memberId;
            this.noteText = internal.noteText;
            this.createdBy = internal.createdBy;
            this.createdOn = internal.createdOn;
            this.noteSource = internal.noteSource;
            this.icon = internal.icon;
            this.iconBgColor = internal.iconBgColor;
        }
    }
}
